module.exports = __webpack_public_path__ + "img/user.90df194e.svg";